import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const topCategoriesStyle = {
    marginBottom: pxToRem(50),
    '.slick-list': {
        paddingLeft: `${pxToRem(10)} !important`,
        paddingTop: `${pxToRem(16)} !important`,
        paddingBottom: `${pxToRem(16)} !important`,
        display: 'flex'
    },
    '.slick-slide': {
        marginRight: pxToRem(15),
        opacity: '0.6',
        transition: 'opacity 0.5s ease, transform 0.5s ease',
        background: 'gray.50',
        [`@media (min-width: ${sizes.container.md})`]: {
            m: `0 ${pxToRem(20)}`
        },
        '&.slick-active': {
            opacity: 1
        },
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: `${pxToRem(0)} ${pxToRem(10)} ${pxToRem(20)} rgba(0, 0, 0, 0.2)`,
            '.slide-content': {
                color: 'cav_red'
            }
        }
    },
    '.slick-track': {
        overflow: 'visible',
        display: 'flex'
    },
    '.slide-item': {
        img: {
            width: '100%'
        },
        a: {
            fontFamily: fonts.primary,
            color: 'black',
            textDecoration: 'none'
        }
    },
    '.slick-arrow': {
        width: pxToRem(40),
        height: pxToRem(40),
        background: 'cav_light_black',
        color: 'white',
        borderRadius: '50%',
        zIndex: 2,

        '&:hover': {
            background: 'black',
            color: 'white'
        }
    },
    '.slick-next': {
        right: pxToRem(29)
    },
    '.slick-prev': {
        left: pxToRem(29)
    },
    '.slide-content': {
        background: 'gray.50',
        padding: `${pxToRem(20)} ${pxToRem(15)}`,

        [`@media (min-width: ${size.md})`]: {
            padding: `${pxToRem(30)} ${pxToRem(20)}`
        },

        h3: {
            fontFamily: fonts.primary,
            fontSize: pxToRem(16),
            fontWeight: '500',
            letterSpacing: pxToRem(1.28),
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(14),
                letterSpacing: pxToRem(1)
            }
        },
        p: {
            fontFamily: fonts.primary,
            fontSize: pxToRem(16),
            fontWeight: '400',
            letterSpacing: pxToRem(1.28),
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(14),
                letterSpacing: pxToRem(1)
            }
        },
        'p:last-of-type': {
            fontFamily: fonts.primary,
            fontSize: pxToRem(14),
            fontWeight: '500',
            letterSpacing: pxToRem(2),
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(12),
                letterSpacing: pxToRem(1)
            }
        }
    },

    h2: {
        textAlign: 'center',
        fontSize: pxToRem(22),
        fontStyle: 'normal',
        fontWeight: 600,
        letterSpacing: pxToRem(3.3),
        textTransform: 'uppercase',
        fontFamily: fonts.primary,
        marginBottom: pxToRem(18),

        [`@media (max-width: ${size.md})`]: {
            fontSize: pxToRem(18),
            letterSpacing: pxToRem(2.7)
        }
    }
}
